export default "__VITE_ASSET__BgNsseUv__"